import { render } from "./ContactComponent.vue?vue&type=template&id=0defac08&scoped=true"
import script from "./ContactComponent.vue?vue&type=script&lang=js"
export * from "./ContactComponent.vue?vue&type=script&lang=js"

import "./ContactComponent.vue?vue&type=style&index=0&id=0defac08&lang=scss&scoped=true"

import exportComponent from "C:\\Projects\\svila\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0defac08"]])

export default __exports__